<template>
  <div class="promocodeApplyInput">
    <div class="promocodeApplyInput__header">
      <div class="promocodeApplyInput__title" @click="showPromocode">
        <i :class="{ 'promocodeApplyInput__icon_show': show }"  class="promocodeApplyInput__icon"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.29289 6.29289C3.68342 5.90237 4.31658 5.90237 4.70711 6.29289L10 11.5858L15.2929 6.29289C15.6834 5.90237 16.3166 5.90237 16.7071 6.29289C17.0976 6.68342 17.0976 7.31658 16.7071 7.70711L10.7071 13.7071C10.3166 14.0976 9.68342 14.0976 9.29289 13.7071L3.29289 7.70711C2.90237 7.31658 2.90237 6.68342 3.29289 6.29289Z" fill="#526C82" fill-opacity="0.8"/>
</svg></i>
        <span>{{ $t('qic_have_promocode') }}</span>
      </div>
    </div>
    <transition name="fade">
      <div class="promocodeApplyInput__input" v-if="show">
        <template v-if="!applied && !invalid">
          <div class="promocodeApplyInput__wrapper-input">
            <BaseInput
              :placeholder="$t('qic_promocode')"
              v-model="promocode"
              name="promocode"
              autocomplete="off"
              @focus="onFocus"
              @blur="onBlur"
              :mask="'X'.repeat(12)"/>
            <button
              v-if="promocode && validation"
              class="promocodeApplyInput__btn"
              :disabled="loading"
              @click="onApply">
              {{ $t('qic_promocode_apply') }}
            </button>
          </div>
        </template>
        <template v-if="applied">
          <div class="promocodeApplyInput__status">
            <div class="promocodeApplyInput__status-input">
              {{promocode}}
              <span @click="change">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.2929 2.29289C15.6834 1.90237 16.3166 1.90237 16.7071 2.29289L21.7071 7.29289C22.0976 7.68342 22.0976 8.31658 21.7071 8.70711L8.70711 21.7071C8.51957 21.8946 8.26522 22 8 22H3C2.44772 22 2 21.5523 2 21V16C2 15.7348 2.10536 15.4804 2.29289 15.2929L15.2929 2.29289ZM4 16.4142V20H7.58579L19.5858 8L16 4.41421L4 16.4142Z" fill="#18B97D"/></svg>
              </span>
            </div>
            <p>{{ $t('qic_promocode_applied') }}</p>
          </div>
        </template>
        <template v-if="invalid">
          <div class="promocodeApplyInput__status promocodeApplyInput__status--invalid">
            <div class="promocodeApplyInput__status-input">
              {{invalid}}
              <span @click="clear">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M18.7071 6.70711C19.0976 6.31658 19.0976 5.68342 18.7071 5.29289C18.3166 4.90237 17.6834 4.90237 17.2929 5.29289L12 10.5858L6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L10.5858 12L5.29289 17.2929C4.90237 17.6834 4.90237 18.3166 5.29289 18.7071C5.68342 19.0976 6.31658 19.0976 6.70711 18.7071L12 13.4142L17.2929 18.7071C17.6834 19.0976 18.3166 19.0976 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.7071 17.2929L13.4142 12L18.7071 6.70711Z" fill="#F94C27"/></svg>
              </span>
            </div>
            <p>{{ $t('qic_promocode_invalid') }}</p>
          </div>
        </template>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  emits: ['input', 'focus', 'blur', 'clickPromocode'],
  props: {
    value: { type: String },
    validation: { type: Function }
  },
  data () {
    return {
      show: false,
      loading: false,
      applied: false,
      invalid: false,
      promocode: this.value
    }
  },
  methods: {
    onFocus () {
      this.$emit('focus')
    },
    onBlur () {
      this.$emit('blur', this.promocode)
    },
    showPromocode () {
      this.show = !this.show
      this.$emit('clickPromocode', this.show)
    },
    onApply () {
      if (this.validation) {
        this.onValidation()
      } else {
        console.warn('No function to validate promocode')
      }
    },
    onValidation () {
      if (!this.promocode) return
      this.loading = true
      this.validation(this.promocode)
        .then((valid) => {
          this.applied = valid
          this.invalid = valid ? '' : this.promocode
          if (valid) {
            this.$emit('input', this.promocode)
          } else {
            this.$emit('input', '')
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    clear () {
      this.applied = false
      this.invalid = false
      this.promocode = ''
      this.$emit('input', '')
    },
    change () {
      this.applied = false
      this.invalid = false
      this.$emit('input', '')
    }
  },
  mounted () {
    if (this.validation) {
      this.onValidation()
    } else {
      this.$emit('input', '')
    }
  }
}
</script>

<style lang="scss" scoped>
  .fade-enter-active, .fade-leave-active {
    transition: .15s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
    opacity: 0;
    transition: .04s;
  }
  .promocodeApplyInput {
    border: 1px solid rgba(82, 108, 130, 0.2);
    border-radius: 16px;
    padding: 24px;

    @media (max-width: 550px) {
      padding: 16px;
    }
    &__status {
      display: grid;
      gap: 16px;
      p {
        font-size: 14px;
        line-height: 24px;
        color: #18B97D;
      }
      &-input {
        padding: 16px;
        width: 100%;
        height: 56px;
        background: rgba(24, 185, 125, 0.1);
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 16px;
        line-height: 24px;
        color: #18B97D;

        span {
          width: 24px;
          height: 24px;
          display: flex;
          align-items: center;
          cursor: pointer;
        }
      }
      &--invalid {
        p {
        color: #F94C27;
        }
        .promocodeApplyInput__status-input {
          background: rgba(249, 185, 125, 0.1);
          color: #F94C27;
        }
      }
    }
    &__wrapper-input {
      position: relative;
    }
    &__btn {
      width: 92px;
      height: 40px;
      background: #5927FF;
      border-radius: 12px;
      display: flex;
      align-items: center;
      border: none;
      cursor: pointer;
      text-align: center;
      justify-content: center;
      font-size: 16px;
      line-height: 24px;
      color: #F1F4F6;
      position: absolute;
      top: 8px;
      z-index: 1;
      inset-inline-end: 8px;
    }
    &__header {
      display: flex;
      align-items: center;
    }
    &__title {
      font-weight: 500;
      align-items: center;
      display: flex;
      font-size: 16px;
      line-height: 24px;
      color: #1C1C1C;
      cursor: pointer;
      span {
        margin-inline-start: 12px;
      }
    }
    &__icon {
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      transition: .2s;
      &_show {
        transform: rotate(-180deg);
      }
    }
    &__optional {
      font-size: 12px;
      line-height: 16px;
      color: rgba(82, 108, 130, 0.8);
    }
    &__input {
      padding-top: 11px;
    }
}
</style>
